import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../layout/common/Footer'
import Header from '../layout/common/Header'
import NavHeader from '../layout/common/NavHeader'
import SidebarTest from '../layout/common/SidebarTest'
import Add from '../layout/theme/Add'

const AddTheme = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Add Theme</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <Add
        // userList={userListData}
        // pageNumber={pageNumber}
        // onChangePageNumber={onChangePageNumberHandler}
        // usersPerPage={perPageRecords}
        // pageCount={pageCount}
        // onChangeSortClick={sortOnClickHandler}
        // onChangeSortType={sortTypeOnClickHandler}
        // onStatusRecordChange={onStatusRecordChangeHandler}
        // onSearchChang={searchValueChange}
        // onPerPageChange={pageChange}
        // onChangeStatus={statusChangeHandler}
        // statusChange={statusChange}
        // onShowUserOnMainPage={showUserOnMainPageHandler}
      />
      <Footer />
    </React.Fragment>
  )
}

export default AddTheme
